export default {
  step: 1,
  schemas: [],
  templates: [],
  visitedStep: 1,
  csvData: {},
  schemaColumns: [],
  fileDataArray: [],
  // addressError: {},
  // addressApproved: {},
  // addressDuplicate: {},

  mappingId: 0,
  rowsToSkip: 0,
  delimiter: '',
  corporateId: 0,
  mappedData: [],
  schemaName: '',
  templateName: '',
  isSkipChecked: false,
  isSelectedData: false,

  delimiterOptions: [
    { name: '', value: '' },
    { name: 'Comma', value: 'Comma' },
    { name: 'Tab', value: 'Tab' }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/import-data/state.js